import { map } from "rxjs";
import { ITableConfiguration } from "../../../../common/TablesConfiguration/tcConstants";
import { GET, PUT } from "../../../../module/services/fetch";

export const fetchTablesConfigurationManagementData = (queryParams: string) =>
  GET(`v1/admin/configurations/tables${queryParams}`).pipe(
    map((response: any) => response)
  );

export const fetchUpdateTablesConfiguration = (body: ITableConfiguration[]) =>
  PUT(`v1/admin/configurations/columns/tables`, body).pipe(
    map((response: any) => response)
  );
